export enum ManifestModal {
  FAILED_TO_GET_MANIFEST = "FAILED_TO_GET_MANIFEST",
  UNKNOWN_ERROR = "UNKNOWN_ERROR",
}
